import React from 'react';
import { LeadForm } from '../LeadForm/LeadForm';
import { presentationContent } from './Presentation.content';

import styles from './Presentation.module.sass';
import cloud from './assets/cloud-1.webp';
import cloud2 from './assets/cloud-2.webp';
import cloud3 from './assets/cloud-4.webp';
import cloud4 from './assets/cloud-4.webp';

export function Presentation() {
  const {
    title,
    subtitle,
    phoneLabel,
    phonePlaceholder,
    nameLabel,
    submitLabel,
    consentLabel,
    disclaimer,
  } = presentationContent;

  return (
    <section className={styles.presentation}>
      <img  alt="" className={styles.presentation__bg} aria-hidden />

      <div className={styles.presentation__inner}>
        <h2 className={styles.presentation__title}>
          {title.map((seg, i) => (
            <React.Fragment key={i}>
              {seg.accent ? (
                <span
                  className={styles.presentation__titleLineAccent}
                  dangerouslySetInnerHTML={{ __html: seg.text }}
                />
              ) : (
                <span
                  className={styles.presentation__titleLine}
                  dangerouslySetInnerHTML={{ __html: seg.text }}
                />
              )}
            </React.Fragment>
          ))}
        </h2>

        <div className={styles.presentation__right}>
          <p className={styles.presentation__subtitle}>
            {subtitle.map((seg, i) => (
              <React.Fragment key={i}>
                {seg.accent ? (
                  <span
                    className={styles.presentation__subtitleLineAccent}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                ) : (
                  <span
                    className={styles.presentation__subtitleLine}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                )}
              </React.Fragment>
            ))}
          </p>

          <LeadForm
            phoneLabel={phoneLabel}
            phonePlaceholder={phonePlaceholder}
            nameLabel={nameLabel}
            submitLabel={submitLabel}
            consentLabel={consentLabel}
            disclaimer={disclaimer}
          />
        </div>
      </div>
      <img  src={cloud} alt="Облако" className={styles['presentation__cloud-1']} />
      <img  src={cloud2} alt="Облако" className={styles['presentation__cloud-2']} />
      <img  src={cloud3} alt="Облако" className={styles['presentation__cloud-3']} />
      <img  src={cloud4} alt="Облако" className={styles['presentation__cloud-4']} />
    </section>
  );
}
